import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { capitalizeFirstLetter, DateFormats, formatDateToString } from '@core';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {
  transform(startDate: string, endDate: string): string {
    const formattedDate: string = capitalizeFirstLetter(formatDateToString(startDate, DateFormats.WeekdayFullDate));
    const startTime: string = formatDateToString(startDate, DateFormats.Time);
    const endTime: string = formatDateToString(endDate, DateFormats.Time);
    return `${formattedDate} | ${startTime} - ${endTime}`;
  }
}
